import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { formatDate } from '@ifca-root/react-component/src/helpers/StringNumberFunction/formatDate'
import { RejectDialog } from 'components/Dialog/RejectDialog'
import {
  useGetUsersByAccountAndSoftwareQuery,
  UserSelection,
} from 'generated/graphql'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useHistory, useLocation, useParams } from 'react-router'
import { ProvisionImpairmentReversalDetailContent } from './ProvisionImpairmentReversalDetailContent'
import { ReversePredevalueDetailContent } from './ReversePredevalueDetailContent'

export const ProvisionImpairmentReversalDetail = (props: any) => {
  let history = useHistory()
  const { mode } = props
  const { CompanyID, provision_impairment_reversal_id }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  let location = useLocation()
  const editData = location?.state as any
  const [openRejectDialog, setOpenRejectDialog] = useState(false)
  const {
    handleSubmit,
    register,
    setValue,
    control,
    errors,
    clearErrors,
  } = useForm<any>()
  const [audioInput, setAudioInput] = useState('')
  const [record, setRecord] = useState(false)
  const [text, setText] = useState(mode === 'add' ? '' : editData?.remark)
  const [singleRemark, setSingleRemark] = useState(null)
  const handleSingleRemark = remark => {
    setSingleRemark(remark)
  }

  const {
    loading: getUsersByAccountAndSoftwareLoading,
    data: { getUsersByAccountAndSoftware } = {
      GetUsersByAccountAndSoftware: [],
    },
  } = useGetUsersByAccountAndSoftwareQuery({
    fetchPolicy: 'network-only',
    variables: {
      superUserBool: UserSelection.All,
    },
  })

  const rejectFooterOption = {
    name: 'Reject',
    onClick: () => {
      setOpenRejectDialog(true)
    },
    color: 'secondary',
    props: { type: 'submit' },
  }

  const approveFooterOption = {
    name: 'Approve',
    onClick: () => {
      setOpenRejectDialog(false)
    },
    color: 'primary',
    props: { type: 'submit' },
  }
  const footerOptions: any[] = [rejectFooterOption, approveFooterOption]

  const getStatusLabel = (status: string) => {
    switch (status) {
      case 'ACTIVE':
        return 'Draft'
      case 'SUBMIT':
        return 'Submitted'
      case 'COMPLETED':
        return 'Approved'
      case 'REJECTED':
        return 'Rejected'
      default:
        return status
    }
  }

  return (
    <>
      {getUsersByAccountAndSoftwareLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push({
            pathname: `/fixed-assets/${CompanyID}/assets-change/provision-for-impairment-reversal`,
          })
        }}
        smTitle="Fixed Assets"
        title={user?.companyName}
        routeSegments={[
          { name: 'Fixed Assets' },
          { name: 'Assets Change' },
          { name: 'Provision for Impairment Reversal' },
        ]}
        rightRouteSegments={[
          { name: getStatusLabel(editData?.ApprovalStatus), current: true },
        ]}
      />

      <DynamicSubHeader
        title={
          <span className="c-orange">
            <span style={{ fontWeight: 'bold' }}>
              {editData?.Asset?.name || 'N/A'}
            </span>
          </span>
        }
        rightText={
          <span className="c-orange">
            <span style={{ fontWeight: 'bold' }}>
              {editData?.DocNo || 'N/A'}
            </span>
          </span>
        }
        infoLine={
          <div
            className="text-overflow"
            style={{ fontSize: '11px', width: '270px' }}
          >
            <span>
              Acc. Impairment:
              <span style={{ textDecoration: 'line-through' }}>
                {editData?.accumulated_impairment || 0}
              </span>
              <span> → </span>
              <span className="c-orange">
                {editData?.accumulated_impairment_reversal || 0}
              </span>
            </span>
          </div>
        }
        rightInfoLine={
          <span>{formatDate(editData?.reversal_date || new Date())}</span>
        }
      />

      <ContentWrapper multiDynamicInfo float footer>
        <CardContents>
          <ProvisionImpairmentReversalDetailContent
            listEl={editData}
            userList={getUsersByAccountAndSoftware}
            mode={'COMPLETED'}
          />
        </CardContents>

        <CardContents
          section={{
            header: { title: 'Reverse PreDevalue' },
          }}
        >
          <ReversePredevalueDetailContent listEl={editData} />
        </CardContents>
      </ContentWrapper>

      {mode === 'workdesk' ? <Footer options={[...footerOptions]} /> : null}

      {editData?.ApprovalStatus === 'SUBMIT' ? (
        <Footer
          options={[
            {
              name: 'Post',
              onClick: () => {},
              color: 'primary',
            },
          ]}
        />
      ) : null}

      <RejectDialog
        data={editData}
        openRejectDialog={openRejectDialog}
        setOpenRejectDialog={setOpenRejectDialog}
        audioInput={audioInput}
        record={record}
        setRecord={setRecord}
        setValue={setValue}
        errors={errors}
        register={register}
        control={control}
        clearErrors={clearErrors}
        setText={setText}
        handleSingleRemark={handleSingleRemark}
      />
    </>
  )
}
